//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { ConnectPanelAction } from '@catalog-ingestion/actions/connectPanelActions';
import { CATALOG_LOCALE_TYPES, CONNECT_PANEL_ACTIONS, CONNECTION_METHODS } from '@catalog-ingestion/constants/connectPanelConstants';
import { IConnectPanelState } from '@catalog-ingestion/models/ConnectPanelModel';

const initialState: IConnectPanelState = {
  selectedLocale: CATALOG_LOCALE_TYPES.EN_US,
  connectionMethod: CONNECTION_METHODS.CatalogURL,
  isValidating: false,
  isUrlEmpty: false,
  isSchedulingValidation: true,
  isCatalogSourceInvalid: false,
  isFileUploading: false,
  didFileUploadFail: false,
  loginName: null,
  password: null,
  catalogUrl: null,
  catalogSource: {
    succeeded: false,
    failureReason: null,
  },
  flags: {
    isValidatingSource: false
  }
};

export default function ConnectPanelReducer(
  state: IConnectPanelState = initialState,
  action: ConnectPanelAction,
): IConnectPanelState {
  switch ( action.type ) {
    case CONNECT_PANEL_ACTIONS.CHANGE_LOCALE:
      return {
        ...state,
        selectedLocale: action.selectedLocale,
      };
    case CONNECT_PANEL_ACTIONS.CHANGE_CONNECTION_METHOD:
      return {
        ...state,
        connectionMethod: action.connectionMethod,
      };
    case CONNECT_PANEL_ACTIONS.TOGGLE_IS_VALIDATING:
      return {
        ...state,
        isValidating: !state.isValidating,
      };
    case CONNECT_PANEL_ACTIONS.SET_IS_URL_EMPTY:
      return {
        ...state,
        isUrlEmpty: action.isUrlEmpty,
      };
    case CONNECT_PANEL_ACTIONS.SET_IS_CATALOG_SOURCE_VALID:
      return {
        ...state,
        isCatalogSourceInvalid: action.isCatalogSourceInvalid,
      };
    case CONNECT_PANEL_ACTIONS.SET_IS_FILE_UPLOADING:
      return {
        ...state,
        isFileUploading: action.isFileUploading,
      };
    case CONNECT_PANEL_ACTIONS.SET_DID_FILE_UPLOAD_FAIL:
      return {
        ...state,
        didFileUploadFail: action.didFileUploadFail,
      };
    case CONNECT_PANEL_ACTIONS.CHANGE_LOGIN:
      return {
        ...state,
        loginName: action.newLoginName,
      };
    case CONNECT_PANEL_ACTIONS.CHANGE_PASSWORD:
      return {
        ...state,
        password: action.newPassword,
      };
    case CONNECT_PANEL_ACTIONS.CHANGE_URL:
      return {
        ...state,
        catalogUrl: action.newCatalogUrl,
      };
    case CONNECT_PANEL_ACTIONS.RESET_CATALOG_URL_CREDENTIALS_STATE:
      return {
        ...initialState,
      };
    case CONNECT_PANEL_ACTIONS.REQUEST_VALIDATE_SOURCE:
      return {
        ...state,
        flags: {
          ...state.flags,
          isValidatingSource: true,
        }
      };
    case CONNECT_PANEL_ACTIONS.RECEIVE_VALIDATE_SOURCE:
      return {
        ...state,
        flags: {
          ...state.flags,
          isValidatingSource: false,
        },
        catalogSource: action.catalogSource
      };
    default:
      return state;
  }
}
